export default {
  getPesquisasSatisfacao: state => state.pesquisasSatisfacao,
  getPesquisaSatisfacaoEspecifica: state => state.pesquisaSatisfacaoEspecifica,
  getPesquisaUse: state => state.pesquisaUse,
  getAudios: state => state.audios,
}
